"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBufferUntilFirstFrame = void 0;
const react_1 = require("react");
const use_buffer_state_1 = require("./use-buffer-state");
const useBufferUntilFirstFrame = ({ mediaRef, mediaType, onVariableFpsVideoDetected, }) => {
    const bufferingRef = (0, react_1.useRef)(false);
    const { delayPlayback } = (0, use_buffer_state_1.useBufferState)();
    const bufferUntilFirstFrame = (0, react_1.useCallback)((requestedTime) => {
        if (mediaType !== 'video') {
            return;
        }
        const current = mediaRef.current;
        if (!current) {
            return;
        }
        if (!current.requestVideoFrameCallback) {
            return;
        }
        bufferingRef.current = true;
        const playback = delayPlayback();
        const unblock = () => {
            playback.unblock();
            current.removeEventListener('ended', unblock, {
                // @ts-expect-error
                once: true,
            });
            current.removeEventListener('pause', unblock, {
                // @ts-expect-error
                once: true,
            });
            bufferingRef.current = false;
        };
        const onEndedOrPause = () => {
            unblock();
        };
        current.requestVideoFrameCallback((_, info) => {
            const differenceFromRequested = Math.abs(info.mediaTime - requestedTime);
            if (differenceFromRequested > 0.5) {
                onVariableFpsVideoDetected();
            }
            // Safari often seeks and then stalls.
            // This makes sure that the video actually starts playing.
            current.requestVideoFrameCallback(() => {
                unblock();
            });
        });
        current.addEventListener('ended', onEndedOrPause, { once: true });
        current.addEventListener('pause', onEndedOrPause, { once: true });
    }, [delayPlayback, mediaRef, mediaType, onVariableFpsVideoDetected]);
    return (0, react_1.useMemo)(() => {
        return {
            isBuffering: () => bufferingRef.current,
            bufferUntilFirstFrame,
        };
    }, [bufferUntilFirstFrame]);
};
exports.useBufferUntilFirstFrame = useBufferUntilFirstFrame;
